(function auditDetailControllerDefinition() {
    'use strict';

    angular.module('Audit')
        .controller('AuditDetailController', [
            '$filter', '$state', '$scope', '$stateParams', 'auditService','fileService',
            function auditDetailController($filter, $state, $scope, $stateParams, auditService, fileService) {

                $scope.load = function () {
                    $scope.showError = false;
                    $scope.isArray = angular.isArray;
                    auditService.getById($stateParams.id).then(function (result) {
                        if (result.value.entity && result.value.actionType) {
                            try {
                                $scope.generalData = result.value;
                                $scope.entity = JSON.parse(result.value.entity);
                                $scope.actionType = result.value.actionType.traslatedName;
                                $scope.filelist = $scope.entity.filelist;
                                if ($scope.filelist && $scope.filelist.length > 0) {
                                    $scope.filelist.forEach(function (file) {
                                        var valueAux = file.value.split('>');
                                        file.value = valueAux[0] + ' - ' + fileService.FormatfileSize(valueAux[1]);
                                    });
                                }

                                delete $scope.entity.filelist;
                            } catch (e) {
                                $scope.showError = true;
                            }
                        }
                    });
                };

                $scope.getValue = function (value) {
                    if (isNaN(value) && !isNaN(Date.parse(value))) {
                        value = $filter('date')(value, 'dd/MM/yyyy HH:mm:ss');
                    }

                    return value;
                };

                $scope.cancel = function () {
                    $state.go('audit-find');
                };

                $scope.load();
            }
        ]);
})();
